import { gql } from "@apollo/client";

export const BULK_CREATE_INVENTORY_RECEIVING_LOG = gql`
    mutation bulkCreateInventoryReceivingLogs($logs: [InventoryReceivingLogInputType]!) {
        bulkCreateInventoryReceivingLogs(logs: $logs) {
            inventoryReceivingLogs {
                id
            }
        }
    }
`

export const EDIT_INVENTORY_RECEIVING_LOG = gql`
    mutation editInventoryReceivingLog($id: Int!, $dateAndTime: DateTime!, $quantity: Int!, $equipment: Int!, $fromJob: Int, $fromPurchaseOrder: Int) {
        editInventoryReceivingLog(id: $id, dateAndTime: $dateAndTime, quantity: $quantity, equipment: $equipment, fromJob: $fromJob, fromPurchaseOrder: $fromPurchaseOrder) {
            inventoryReceivingLog {
                id
            }
        }
    }
`